// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ExpertOut = zod.object({
  "display_name": zod.string(),
  "email": zod.string(),
  "is_active": zod.boolean(),
  "label": zod.union([zod.string(),zod.null()]),
  "not_signed_in_until": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "position": zod.int(),
  "user_id": zod.uuid()
});

export type ExpertOut = zod.input<typeof ExpertOut>;
export type ExpertOutOutput = zod.output<typeof ExpertOut>;
